import { ArrowDownIcon } from 'lucide-react'

import { Separator } from '@/components/separator/separator'

import { EXTERNAL_URLS } from '@/lib/constants/url'
import { cn } from '@/lib/utils'

import { SignUpForm } from './ui/form'
import { Headline } from './ui/headline'
import { Slideshow } from './ui/slideshow/slideshow'

export const SignUpPage = () => {
  return (
    <div className={cn('flex', 'h-full')}>
      <div className={cn('flex flex-1 flex-col', 'px-6', 'overflow-y-auto')}>
        <div className={cn('pt-8')}>
          <img src={EXTERNAL_URLS.lawfullyProFullLogo} alt="Lawfully Pro Logo" />
        </div>

        <div className={cn('flex flex-1 flex-col items-center justify-start', 'lg:justify-center', 'py-8')}>
          <Headline />
          <Separator className={cn('relative', 'max-w-[515px]', 'mb-4 mt-10')}>
            <span
              className={cn(
                'absolute left-[50%] translate-y-[-50%]',
                'bg-white',
                'p-2',
                'rounded-[50%] border border-border'
              )}
            >
              <ArrowDownIcon size={16} className={cn('text-muted-foreground')} />
            </span>
          </Separator>
          <SignUpForm />
        </div>
      </div>

      <div className={cn('hidden lg:flex lg:flex-1 lg:items-center lg:justify-center', 'bg-[hsla(226,100%,28%,1)]')}>
        <Slideshow />
      </div>
    </div>
  )
}
